"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMergeHTMLProps = void 0;

exports.deepMergeHTMLProps = function (mainProps, secondaryProps) {
  var newProps = __assign({}, mainProps);

  var _loop_1 = function _loop_1(key) {
    var secondaryVal = secondaryProps[key];

    if (!newProps[key]) {
      newProps[key] = secondaryVal;
      return "continue";
    }

    if (key === "className") {
      newProps[key] += " " + secondaryVal;
      return "continue";
    }

    if (key === "style") {
      newProps[key] = __assign(__assign({}, secondaryVal), newProps[key]);
    }

    if (typeof newProps[key] === "function" && typeof secondaryVal === "function") {
      // function
      var fn1_1 = newProps[key];
      var fn2_1 = secondaryVal;

      newProps[key] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        fn1_1.apply(void 0, __spread(args));
        fn2_1.apply(void 0, __spread(args));
      };
    }
  };

  for (var key in secondaryProps) {
    _loop_1(key);
  }

  return newProps;
};